import type { Recipe } from '../../domain/recipe';

// DE: Frühstücke für zwei Portionen; werktags die gewohnten Eier, am Wochenende Abwechslung.
// EN: Breakfasts for two portions; the usual eggs on workdays, variety at weekends.
// prettier-ignore
export const BREAKFAST_RECIPES: readonly Recipe[] = [
  {
    id: 'eggs_toast', name: 'Яєчня з цільнозерновим тостом', cuisine: 'other', meal: 'breakfast',
    nameDe: 'Spiegeleier mit Vollkorntoast',
    activeMinutes: 10, totalMinutes: 10, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'eggs', quantity: 4 }, { productId: 'toast_wholegrain', quantity: 120 },
      { productId: 'butter', quantity: 10 }, { productId: 'tomato', quantity: 150 },
    ],
    steps: ['Підсмажити тости.', 'Посмажити яйця на маслі, подавати з помідором.'],
    stepsDe: ['Toast rösten.', 'Eier in Butter braten und mit Tomate servieren.'],
  },
  {
    id: 'eggs_lavash', name: 'Яєчня з лавашем і сиром', cuisine: 'other', meal: 'breakfast',
    nameDe: 'Spiegeleier mit Lavash und Käse',
    activeMinutes: 10, totalMinutes: 10, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'eggs', quantity: 4 }, { productId: 'lavash', quantity: 100 },
      { productId: 'cheese', quantity: 40 }, { productId: 'cucumber', quantity: 0.5 },
    ],
    steps: ['Посмажити яйця, посипати тертим сиром.', 'Загорнути в лаваш і подавати з огірком.'],
    stepsDe: ['Eier braten und mit geriebenem Käse bestreuen.', 'In Lavash einwickeln und mit Gurke servieren.'],
  },
  {
    id: 'syrnyky', name: 'Сирники зі сметаною та ягодами', cuisine: 'ukrainian', meal: 'breakfast',
    nameDe: 'Syrnyky (Quarkküchlein) mit Schmand und Beeren',
    activeMinutes: 20, totalMinutes: 25, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'quark', quantity: 500 }, { productId: 'eggs', quantity: 2 }, { productId: 'flour', quantity: 80 },
      { productId: 'sugar', quantity: 20 }, { productId: 'oil', quantity: 20 }, { productId: 'sour_cream', quantity: 100 },
      { productId: 'berries', quantity: 150 },
    ],
    steps: [
      'Змішати кварк, яйця, цукор і борошно.',
      'Сформувати сирники й смажити по 3 хвилини з кожного боку.',
      'Подавати зі сметаною та розмороженими ягодами.',
    ],
    stepsDe: [
      'Quark, Eier, Zucker und Mehl verrühren.',
      'Kleine Küchlein formen und von jeder Seite 3 Minuten braten.',
      'Mit Schmand und aufgetauten Beeren servieren.',
    ],
  },
  {
    id: 'oat_pancakes', name: 'Вівсяні оладки з бананом і йогуртом', cuisine: 'other', meal: 'breakfast',
    nameDe: 'Haferpfannkuchen mit Banane und Joghurt',
    activeMinutes: 15, totalMinutes: 20, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'oats', quantity: 120 }, { productId: 'banana', quantity: 200 }, { productId: 'eggs', quantity: 3 },
      { productId: 'yogurt', quantity: 200 }, { productId: 'oil', quantity: 15 },
    ],
    steps: ['Розім’яти банан, змішати з яйцями й вівсянкою.', 'Смажити невеликі оладки, подавати з йогуртом.'],
    stepsDe: ['Banane zerdrücken und mit Eiern und Haferflocken verrühren.', 'Kleine Pfannkuchen braten und mit Joghurt servieren.'],
  },
  {
    id: 'shakshuka', name: 'Шакшука з хлібом', cuisine: 'other', meal: 'breakfast',
    nameDe: 'Shakshuka mit Brot',
    activeMinutes: 15, totalMinutes: 25, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'eggs', quantity: 4 }, { productId: 'canned_tomatoes', quantity: 400 },
      { productId: 'paprika', quantity: 250 }, { productId: 'onion', quantity: 100 }, { productId: 'bread', quantity: 100 },
      { productId: 'paprika_powder', quantity: 3 }, { productId: 'oil', quantity: 15 },
    ],
    steps: [
      'Обсмажити цибулю й перець, додати томати й паприку, тушкувати 10 хвилин.',
      'Зробити заглиблення, вбити яйця й готувати під кришкою 5 хвилин.',
      'Подавати з хлібом.',
    ],
    stepsDe: [
      'Zwiebel und Paprika anbraten, Tomaten und Paprikapulver dazugeben und 10 Minuten schmoren.',
      'Mulden formen, Eier hineinschlagen und zugedeckt 5 Minuten garen.',
      'Mit Brot servieren.',
    ],
  },
  {
    id: 'oatmeal_berries', name: 'Вівсянка з ягодами та йогуртом', cuisine: 'other', meal: 'breakfast',
    nameDe: 'Haferbrei mit Beeren und Joghurt',
    activeMinutes: 5, totalMinutes: 10, baseServings: 2, lunchboxFriendly: false, backupKit: false,
    ingredients: [
      { productId: 'oats', quantity: 100 }, { productId: 'milk', quantity: 400 },
      { productId: 'berries', quantity: 150 }, { productId: 'yogurt', quantity: 150 },
    ],
    steps: ['Зварити вівсянку на молоці (5 хвилин).', 'Додати ягоди й йогурт.'],
    stepsDe: ['Haferflocken in Milch kochen (5 Minuten).', 'Beeren und Joghurt dazugeben.'],
  },
];
